import React, { useCallback } from 'react';
import {
  Box,
  Checkbox,
  FormControl,
  FormGroup,
  Typography,
  Chip,
  useTheme,
  Tooltip,
} from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { useStyles } from './FilterOptions.style';
import { nanoid } from 'nanoid';

const FiltersOperatorOptions = (props) => {
  const classes = useStyles();
  const theme = useTheme();

  const isRegisteredSelected = (aliases) => {
    const aliasesSet = new Set(aliases);
    return props.selected.some((selectedValue) => aliasesSet.has(selectedValue));
  };

  return (
    <>
      <Box sx={{ display: 'flex' }} key={nanoid()}>
        <FormControl sx={{ m: 3 }} component='fieldset' variant='standard' className={classes.formControl}>
          <FormGroup key={nanoid()} className={classes.optionsGridContainer_medium}>
            {props.items.map((operator) => (
              <Box key={nanoid()} sx={{ mb: 1 }}>
                <FormControlLabel
                  className={classes?.checkboxLabels}
                  label={
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      {operator.name}
                      {operator.registered === true && (
                        <Tooltip title='Registered user' placement='top'>
                          <div style={{ display: 'inline-block' }}>
                            <Chip
                              label='R'
                              size='small'
                              sx={{
                                height: '16px',
                                fontSize: '0.6rem',
                                minWidth: '16px',
                                ml: 1,
                              }}
                              style={{
                                marginLeft: '8px',
                                backgroundColor: 'white !important',
                                color: '#47ba5d',
                                border: `1px solid #47ba5d !important`,
                              }}
                            />
                          </div>
                        </Tooltip>
                      )}
                    </Box>
                  }
                  control={
                    <Checkbox
                      size={'small'}
                      name={operator.name}
                      checked={isRegisteredSelected(
                        operator.registered === true && operator.aliases
                          ? operator.aliases
                          : [operator.name.toLowerCase()]
                      )}
                      onChange={(e) =>
                        props.onChange(
                          operator.registered === true && operator.aliases
                            ? operator.aliases
                            : [operator.name.toLowerCase()],
                          e.target.checked
                        )
                      }
                      className={classes?.checkboxLabels}
                    />
                  }
                />
                {operator.registered === true && operator.aliases && (
                  <Box sx={{ paddingLeft: 4, mt: 0.5 }}>
                    <Box component='ul' sx={{ margin: 0, paddingLeft: 2, listStyle: 'disc' }}>
                      {operator.aliases.map((alias) => (
                        <Box
                          component='li'
                          key={alias}
                          sx={{
                            fontSize: '0.75rem',
                            color: 'text.secondary',
                            mb: 0.3,
                            lineHeight: 1,
                          }}
                        >
                          {alias.trim()}
                        </Box>
                      ))}
                    </Box>
                  </Box>
                )}
              </Box>
            ))}
          </FormGroup>
        </FormControl>
      </Box>
    </>
  );
};

FiltersOperatorOptions.displayName = 'FiltersOperatorOptions';
export default FiltersOperatorOptions;
